// Authentication interceptor for better session management
export const authInterceptor = {
  // Check if response indicates auth failure
  isAuthError: (response: Response): boolean => {
    return response.status === 401 || response.status === 403;
  },

  // Handle auth errors consistently
  handleAuthError: (error: any): boolean => {
    // Check for trial expired (403 with trialExpired flag)
    if (error?.trialExpired || (error?.message && error.message.includes('trialExpired'))) {
      console.log('🔒 Trial expired detected, redirecting to billing...');
      
      // Redirect to billing page with trial_expired flag
      if (window.location.pathname !== '/billing') {
        window.location.href = '/billing?trial_expired=true';
      }
      return true;
    }
    
    // Check for unauthorized (401)
    if (error?.message?.includes('401') || error?.message?.includes('Unauthorized')) {
      // Clear any cached auth data
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      
      // Redirect to login page if not already there
      if (window.location.pathname !== '/simple-login') {
        window.location.href = '/simple-login';
      }
      return true;
    }
    
    return false;
  },
  
  // Check if response is a trial expiration or "choose plan" error (403)
  async checkTrialExpired(response: Response): Promise<boolean> {
    if (response.status === 403) {
      try {
        const clonedResponse = response.clone();
        const data = await clonedResponse.json();
        
        if (data.trialExpired) {
          console.log('🔒 Trial expired detected in response, redirecting to billing...');
          if (window.location.pathname !== '/billing') {
            window.location.href = '/billing?trial_expired=true';
          }
          return true;
        }
        // No subscription yet — must choose a plan (Stripe-first flow)
        if (data.requiresPayment) {
          console.log('🔒 Subscription required, redirecting to billing...');
          if (window.location.pathname !== '/billing') {
            window.location.href = '/billing';
          }
          return true;
        }
      } catch (e) {
        // If parsing fails, ignore
      }
    }
    return false;
  },

  // Add auth headers if available.
  // Server should use only JWT for contractor ID (secure). We still send X-Contractor-ID
  // so older deployments that haven’t been updated yet keep working until backend is redeployed.
  addAuthHeaders: (headers: HeadersInit = {}): HeadersInit => {
    const accessToken = localStorage.getItem('accessToken');
    const user = localStorage.getItem('user');
    const authHeaders: HeadersInit = { ...headers };

    if (accessToken) {
      authHeaders['Authorization'] = `Bearer ${accessToken}`;
    }

    if (user) {
      try {
        const userData = JSON.parse(user);
        if (userData?.id) {
          authHeaders['X-Contractor-ID'] = String(userData.id);
        }
      } catch {
        // ignore
      }
    }

    return authHeaders;
  }
};